var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "recovery-instructions",
    transform: "translate(-858.000000, -251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Alerts/Success",
    transform: "translate(858.000000, 251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.750000, 0.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25,40.5 C9.06671159,40.5 0,31.4334824 0,20.2504332 C0,9.06651764 9.06671159,0 20.25,0 C31.4341548,0 40.5,9.06651764 40.5,20.2504332 C40.5,31.4334824 31.4341548,40.5 20.25,40.5 Z",
    id: "Fill-52",
    fill: "#00C66F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-54",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "11.25 21.2843439 15.1481038 26.1790416 28.3184216 15.75"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "static/media/checkSuccess.38b1b24c6bb38518d0841f7ce2d8249d.svg";
export { ForwardRef as ReactComponent };